module.exports = __webpack_public_path__ + "static/hero-2743f7877f97a10744acf6ef7fca2221.jpg";